import * as React from "react";
const SvgFiRrChevronDoubleUp = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#062147"
      d="M.012 12a1 1 0 0 1 .293-.707l8.172-8.17a5 5 0 0 1 7.07 0l8.172 8.17a1 1 0 0 1-1.414 1.414l-8.172-8.17a3 3 0 0 0-4.242 0l-8.172 8.17A1 1 0 0 1 .012 12"
    />
    <path
      fill="#062147"
      d="M.012 22a1 1 0 0 1 .293-.706l9.586-9.586a3 3 0 0 1 4.242 0l9.586 9.586a1 1 0 0 1-1.414 1.413l-9.586-9.586a1 1 0 0 0-1.414 0l-9.586 9.587A1 1 0 0 1 .012 22"
    />
  </svg>
);
export default SvgFiRrChevronDoubleUp;
